"use client";
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

interface ReviewProps {
  reviewData: any;
}

const Review: React.FC<ReviewProps> = ({ reviewData }) => {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    className: "myCustomCarousel",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {reviewData && reviewData?.length > 1 ? (
        <Box
          sx={{
            marginTop: { xs: "2rem", sm: "3rem" },
            background: "#80808019",
            padding: "1rem 0px",
          }}
        >
          <Grid item container xs={11.5} sm={12} md={12} lg={12} margin="auto">
            <Box
              sx={{
                textAlign: "center",
                flexDirection: "column",
                alignItems: "center",
                width: "100% ",
              }}
            >
              <Box
                sx={{
                  width: "auto",
                  textAlign: "center",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "1rem auto 2rem",
                }}
              >
                <Typography variant="body2" className="playball-regular">
                  Hear From Our
                </Typography>
                &nbsp; &nbsp;
                <Typography variant="h4" className="lexend-heading">
                  HAPPY CUSTOMERS
                </Typography>
              </Box>
              <Box>
                <Slider {...settings}>
                  {reviewData?.map((item: any, index: number) => (
                    <Box
                      key={index}
                      sx={{
                        minWidth: "17rem",
                        minHeight: "24rem",
                        borderRadius: "1.5rem 0px 1.5rem 0px",
                        position: "relative",
                        background: "white",
                        padding: "1rem",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 8px 2px",
                        maxWidth: {
                          xs: "80%",
                          sm: "80%",
                          md: "80%",
                          lg: "80%",
                        },
                        margin: "0.5rem auto",
                      }}
                    >
                      <Box className="testimonial-icon">
                        <FormatQuoteIcon sx={{ fontSize: "2rem" }} />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "8px auto",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ textTransform: "capitalize" }}
                        >
                          {item?.name}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "black",
                          margin: "8px auto",
                        }}
                      >
                        <StarRating rating={item?.rating} />
                      </Box>
                      <Box
                        sx={{
                          overflow: "scroll",
                          "&:: -webkit-scrollbar": {
                            display: "none",
                          },
                        }}
                      >
                        {item?.professionalStatements?.map(
                          (item: any, index: number) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "start",
                              }}
                              key={index}
                            >
                              <CheckIcon
                                sx={{
                                  color: "#15741a",
                                  paddingRight: "5px",
                                  fontSize: "1rem",
                                }}
                              />
                              <Typography
                                variant="caption"
                                sx={{ color: "black", textAlign: "left" }}
                              >
                                {item?.value}
                              </Typography>
                            </Box>
                          )
                        )}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          margin: "8px auto",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            textTransform: "capitalize",
                            position: "absolute",
                            bottom: 10,
                            color: "#15741a",
                            height: "3em",
                            maxWidth: "-webkit-fill-available",
                            margin: "0px 16px",
                            fontWeight: "bold",
                            overflow: "scroll",
                            "&:: -webkit-scrollbar": {
                              display: "none",
                            },
                          }}
                        >
                          {item?.feedback}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Slider>
              </Box>
            </Box>
          </Grid>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};

interface StarRatingProps {
  rating: any;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    const starColor = i <= rating ? "#15741a" : "#d2cccc";
    stars.push(
      <StarIcon
        key={i}
        sx={{
          fontSize: "22px",
          color: starColor,
          marginRight: "8px",
        }}
      />
    );
  }

  return <>{stars}</>;
};

export default Review;
